<template>
  <div class="filter-bar">
    <div class="filter-row">
      <div class="filter-item filter-item-keyword">
        <label>实际承运人姓名 / 手机</label>
        <input
          v-model.trim="query.keyword"
          type="text"
          placeholder="搜索姓名或手机号"
        />
      </div>
      <div class="filter-item filter-item-id">
        <label>身份证号</label>
        <input
          v-model.trim="query.identificationNumber"
          type="text"
          placeholder="身份证号"
        />
      </div>
      <div class="filter-item filter-item-plate">
        <label>主驾车辆</label>
        <input
          v-model.trim="query.vehiclePlate"
          type="text"
          placeholder="车牌号"
        />
      </div>
      <div class="filter-item">
        <label>审核状态</label>
        <select v-model="query.authStatus">
          <option value="">全部</option>
          <option
            v-for="item in authStatusOptions"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</option
          >
        </select>
      </div>
      <div class="filter-item">
        <label>实际承运人状态</label>
        <select v-model="query.driverStatus">
          <option value="">全部</option>
          <option
            v-for="item in driverStatusOptions"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</option
          >
        </select>
      </div>
      <div class="filter-actions">
        <button class="btn btn-primary" type="button" @click="onSearch">
          查询
        </button>
        <button class="btn btn-plain" type="button" @click="onReset">
          重置
        </button>
        <button
          type="button"
          class="filter-adv-toggle"
          :class="{ 'is-open': advancedOpen }"
          @click="toggleAdvanced"
        >
          <span>{{ advancedOpen ? "收起筛选" : "高级筛选" }}</span>
          <svg
            class="adv-chev"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
      </div>
    </div>
    <div
      v-show="advancedOpen"
      class="filter-row filter-row-bordered filter-adv-row"
    >
      <div class="filter-item">
        <label>车辆经营性质</label>
        <select v-model="query.vehicleNature">
          <option value="">全部</option>
          <option
            v-for="item in vehicleNatureOptions"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</option
          >
        </select>
      </div>
      <div class="filter-item filter-item-narrow">
        <label>是否挂车</label>
        <select v-model="query.isTrailer">
          <option value="">全部</option>
          <option :value="true">是</option>
          <option :value="false">否</option>
        </select>
      </div>
      <div class="filter-item">
        <label>客服确认</label>
        <select v-model="query.confirmStatus">
          <option value="">全部</option>
          <option
            v-for="item in confirmStatusOptions"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</option
          >
        </select>
      </div>
      <div class="filter-item">
        <label>财务绑定</label>
        <select v-model="query.bankBindStatus">
          <option value="">全部</option>
          <option
            v-for="item in bankBindStatusOptions"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</option
          >
        </select>
      </div>
      <div class="filter-item">
        <label>税务上报</label>
        <select v-model="query.taxReportStatus">
          <option value="">全部</option>
          <option
            v-for="item in taxReportStatusOptions"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</option
          >
        </select>
      </div>
      <div class="filter-item">
        <label>交通入库</label>
        <select v-model="query.trafficReportStatus">
          <option value="">全部</option>
          <option
            v-for="item in trafficReportStatusOptions"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</option
          >
        </select>
      </div>
      <div class="filter-item filter-item-person">
        <label>审核人</label>
        <input
          v-model.trim="query.authPerson"
          type="text"
          placeholder="审核人"
        />
      </div>
    </div>
    <div
      v-show="advancedOpen"
      class="filter-row filter-adv-row filter-adv-row-2"
    >
      <div class="filter-item filter-item-range">
        <label>注册时间</label>
        <el-date-picker
          v-model="query.regRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          @change="value => changeDate(value, 'reg')"
        />
      </div>
      <div class="filter-item filter-item-range">
        <label>审核时间</label>
        <el-date-picker
          v-model="query.authRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          @change="value => changeDate(value, 'auth')"
        />
      </div>
      <div class="filter-item filter-item-range">
        <label>注销时间</label>
        <el-date-picker
          v-model="query.cancelRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          @change="value => changeDate(value, 'cancel')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  AUTH_STATUS_OPTIONS,
  DRIVER_STATUS_OPTIONS,
  VEHICLE_NATURE_OPTIONS,
  CONFIRM_STATUS_OPTIONS,
  TAX_REPORT_STATUS_OPTIONS,
  TRAFFIC_REPORT_STATUS_OPTIONS,
  BANK_BIND_STATUS_OPTIONS
} from "../constants";

export default {
  name: "DriverFilterBar",
  props: {
    query: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      advancedOpen: false,
      authStatusOptions: AUTH_STATUS_OPTIONS,
      driverStatusOptions: DRIVER_STATUS_OPTIONS,
      vehicleNatureOptions: VEHICLE_NATURE_OPTIONS,
      confirmStatusOptions: CONFIRM_STATUS_OPTIONS,
      taxReportStatusOptions: TAX_REPORT_STATUS_OPTIONS,
      trafficReportStatusOptions: TRAFFIC_REPORT_STATUS_OPTIONS,
      bankBindStatusOptions: BANK_BIND_STATUS_OPTIONS
    };
  },
  methods: {
    onSearch() {
      this.$emit("search");
    },
    onReset() {
      this.$emit("reset");
    },
    toggleAdvanced() {
      this.advancedOpen = !this.advancedOpen;
    },
    // 日期区间：与运单管理一致，拆分为 Start / End 两个查询字段
    changeDate(value, prefix) {
      if (value) {
        this.query[`${prefix}Start`] = value[0];
        this.query[`${prefix}End`] = value[1];
      } else {
        this.query[`${prefix}Start`] = "";
        this.query[`${prefix}End`] = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$brand: #2e5ff0;
$brand-dark: #2049c9;
$brand-light: #edf4ff;
$brand-soft: rgba(46, 95, 240, 0.07);
$bg-card: #ffffff;
$border-soft: #e6eaf1;
$border-cell: #f0f1f3;
$text-1: #1d1f2c;
$text-2: #667085;
$text-3: #98a2b3;
$muted: #c2c9d8;
$radius-sm: 6px;
$radius-md: 8px;

.filter-bar {
  background: $bg-card;
  padding: 14px 20px;
  border-radius: $radius-md;
  margin-bottom: 16px;
  border: 1px solid $border-soft;

  .filter-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: flex-end;

    &.filter-row-bordered {
      margin-top: 12px;
      padding-top: 14px;
      border-top: 1px solid $border-cell;
    }

    &.filter-adv-row-2 {
      margin-top: 12px;
      gap: 40px;
    }
  }

  .filter-item {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 118px;
    flex: 1;

    // 姓名/手机：内容较短
    &.filter-item-keyword {
      flex: 1.2;
      min-width: 170px;
    }

    // 身份证号：18 位，最宽
    &.filter-item-id {
      flex: 1.9;
      min-width: 210px;
    }

    // 车牌号：7 位左右
    &.filter-item-plate {
      flex: 1.15;
      min-width: 150px;
    }

    // 短下拉（是否挂车等）
    &.filter-item-narrow {
      flex: 0.75;
      min-width: 96px;
    }

    // 审核人
    &.filter-item-person {
      flex: 1;
      min-width: 120px;
    }

    // 时间区间：el-date-picker 日期区间（与运单管理一致）
    &.filter-item-range {
      flex: 1.6;
      min-width: 300px;

      ::v-deep .el-range-editor.el-input__inner {
        width: 100%;
      }
    }

    label {
      color: $text-2;
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
    }

    > input,
    > select {
      height: 32px;
      padding: 0 10px;
      border: 1px solid $border-soft;
      border-radius: $radius-sm;
      font-size: 13px;
      outline: none;
      background: $bg-card;
      color: $text-1;
      transition: all 0.2s;
      font-family: inherit;
      width: 100%;

      &:focus {
        border-color: $brand;
        box-shadow: 0 0 0 3px $brand-soft;
      }

      &::placeholder {
        color: $muted;
      }
    }

    select {
      cursor: pointer;
    }
  }

  .filter-actions {
    display: flex;
    gap: 8px;
    margin-left: auto;
    align-items: flex-end;
    flex: none;
  }

  .filter-adv-toggle {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 32px;
    padding: 0 10px;
    border: 1px solid $border-soft;
    background: $bg-card;
    color: $text-2;
    border-radius: $radius-sm;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    font-family: inherit;
    transition: all 0.2s;

    &:hover,
    &.is-open {
      border-color: $brand;
      color: $brand;
      background: $brand-soft;
    }

    .adv-chev {
      transition: transform 0.2s;
    }

    &.is-open .adv-chev {
      transform: rotate(180deg);
    }
  }
}

.btn {
  height: 34px;
  padding: 0 16px;
  border-radius: $radius-sm;
  border: 1px solid $border-soft;
  background: $bg-card;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-weight: 500;
  color: #333333;
  white-space: nowrap;
  font-family: inherit;
  line-height: 1;

  &:hover {
    border-color: $brand;
    color: $brand;
    background: $brand-light;
  }

  &.btn-primary {
    background: $brand;
    color: #fff;
    border-color: $brand;
    font-weight: 600;
    box-shadow: 0 2px 6px rgba(46, 95, 240, 0.28);

    &:hover {
      background: $brand-dark;
      border-color: $brand-dark;
      color: #fff;
      box-shadow: 0 4px 12px rgba(46, 95, 240, 0.38);
    }
  }

  &.btn-plain {
    height: 32px;
    padding: 0 14px;
    font-size: 13px;
  }
}
</style>
